export const libraryRoutes = {
  snippets: '/library/snippet',
  snippetNames: '/library/snippet/names',
  snippet: (token: string) => `/library/snippet/${token}`,
  snippetMetadata: (token: string) => `/library/snippet/${token}/metadata`,
  snippetVersion: (token: string, version: number) => `/library/snippet/${token}/versions/${version}`,
  snippetVersions: (token: string) => `/library/snippet/${token}/versions`,
  publishSnippet: (token: string) => `/library/snippet/${token}/publish`,
  unpublishSnippet: (token: string) => `/library/snippet/${token}/unpublish`,
  archiveSnippet: (token: string) => `/library/snippet/${token}/archive`,
  unarchiveSnippet: (token: string) => `/library/snippet/${token}/unarchive`,
  filters: '/library/filters',
} as const;
